// removed by extract-text-webpack-plugin
module.exports = {"avatarList":"antd-pro-avatar-list-avatarList","avatarItem":"antd-pro-avatar-list-avatarItem","avatarItemLarge":"antd-pro-avatar-list-avatarItemLarge","avatarItemSmall":"antd-pro-avatar-list-avatarItemSmall","avatarItemMini":"antd-pro-avatar-list-avatarItemMini"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/src/components/AvatarList/index.less
// module id = 1120
// module chunks = 0